import { StatusIdEnum } from "./statusId";

export enum CrispTemplateEnum {
    NovaCotacao,
    NovaCotacaoV2,
    AguardandoConfirmacao,
    AguardandoConfirmacaoV2,
    PrevisaoEntregaProxima,
    PedidoAtrasado,
    AprovacaoCotacao,
    AguardandoDevolucaoTroca
}

export function getCrispTemplateStatusId(statusId: number): CrispTemplateEnum {
    switch(statusId){
        case StatusIdEnum.AguardandoConfirmacaoDevolucao:
        case StatusIdEnum.AguardandoConfirmacaoTroca:
            return CrispTemplateEnum.AguardandoDevolucaoTroca;
        default:
            return CrispTemplateEnum.AguardandoConfirmacaoV2;
    }
}